export enum RequestMethod {
  GET = "get",
  PUT = "put",
  PATCH = "patch",
  POST = "post",
  DELETE = "delete",
}
